import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ReportsService, ActivityLogModel, ReportSummary, ReportUser } from '../../Services/reports.service';
import { WithdrawalLogModel } from '../../Models/withdrawal-log.model';
import { ReturnLogModel } from '../../Models/return-log.model';

@Component({
  selector: 'app-berichte',
  templateUrl: './berichte.component.html',
  styleUrls: ['./berichte.component.css']
})
export class BerichteComponent implements OnInit {
  // Filter
  users: ReportUser[] = [];
  selectedUserId = '';
  dateFrom = new FormControl<Date | null>(null);
  dateTo = new FormControl<Date | null>(null);

  // Summary
  summary: ReportSummary | null = null;

  // Tab index
  selectedTab = 0;

  // Tables
  withdrawalColumns = ['timestamp', 'userName', 'elementName', 'quantity', 'purpose', 'comments', 'isReturned'];
  withdrawalDataSource = new MatTableDataSource<WithdrawalLogModel>([]);
  @ViewChild('withdrawalPaginator') withdrawalPaginator!: MatPaginator;
  @ViewChild('withdrawalSort') withdrawalSort!: MatSort;

  returnColumns = ['timestamp', 'userName', 'elementName', 'quantity', 'reason', 'comments'];
  returnDataSource = new MatTableDataSource<ReturnLogModel>([]);
  @ViewChild('returnPaginator') returnPaginator!: MatPaginator;
  @ViewChild('returnSort') returnSort!: MatSort;

  activityColumns = ['timestamp', 'userId', 'action'];
  activityDataSource = new MatTableDataSource<ActivityLogModel>([]);
  @ViewChild('activityPaginator') activityPaginator!: MatPaginator;
  @ViewChild('activitySort') activitySort!: MatSort;

  isLoading = false;

  // Map userId -> userName for activity logs
  private userMap: Map<string, string> = new Map();

  constructor(private reportsService: ReportsService) {}

  ngOnInit(): void {
    this.reportsService.getUsers().subscribe((users: ReportUser[]) => {
      this.users = users;
      users.forEach((u: ReportUser) => this.userMap.set(u.id, u.userName));
    });
    this.loadData();
  }

  loadData(): void {
    this.isLoading = true;
    const from = this.dateFrom.value ? this.dateFrom.value.toISOString() : undefined;
    const to = this.dateTo.value ? this.dateTo.value.toISOString() : undefined;
    const userId = this.selectedUserId || undefined;

    this.reportsService.getSummary(from, to).subscribe((s: ReportSummary) => this.summary = s);

    this.reportsService.getWithdrawals(from, to, userId).subscribe((data: WithdrawalLogModel[]) => {
      this.withdrawalDataSource.data = data;
      setTimeout(() => {
        this.withdrawalDataSource.paginator = this.withdrawalPaginator;
        this.withdrawalDataSource.sort = this.withdrawalSort;
      });
    });

    this.reportsService.getReturns(from, to, userId).subscribe((data: ReturnLogModel[]) => {
      this.returnDataSource.data = data;
      setTimeout(() => {
        this.returnDataSource.paginator = this.returnPaginator;
        this.returnDataSource.sort = this.returnSort;
      });
    });

    this.reportsService.getActivityLogs(from, to, userId).subscribe((data: ActivityLogModel[]) => {
      this.activityDataSource.data = data;
      this.isLoading = false;
      setTimeout(() => {
        this.activityDataSource.paginator = this.activityPaginator;
        this.activityDataSource.sort = this.activitySort;
      });
    });
  }

  getUserName(userId: string): string {
    return this.userMap.get(userId) || userId;
  }

  resetFilters(): void {
    this.selectedUserId = '';
    this.dateFrom.setValue(null);
    this.dateTo.setValue(null);
    this.loadData();
  }
}
